export const UPDATE_VALUE = 'UPDATE_VALUE'
export const SET_NOTE = 'SET_NOTE'
export const SET_OPTIONS = 'SET_OPTIONS'
export const SET_EXPORTS = 'SET_EXPORTS'
